/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Private_Models_Hint_Tools_InconclusiveInputs */



/**
* | output |
* | --- |
* | "The tool-calling test was inconclusive. Tools stay on; switch them off if tool calls fail." |
*
* @param {Private_Models_Hint_Tools_InconclusiveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_hint_tools_inconclusive = /** @type {((inputs?: Private_Models_Hint_Tools_InconclusiveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Hint_Tools_InconclusiveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Tool-Test war nicht eindeutig. Tools bleiben an; schalten Sie sie ab, wenn Tool-Aufrufe scheitern.")
	return /** @type {LocalizedString} */ ("The tool-calling test was inconclusive. Tools stay on; switch them off if tool calls fail.")
});